<b2b-form-change-invoice-status
    [pending]="pending$ | async"
    [stCode]="stCode"
    (cancel)="dialogRef.close()"
    (submitForm)="handlerConfirm($event)" />
